import React from 'react'
import styled from 'styled-components'

// components
import { BoxShadow } from '../../../components/atom'

// styles
import colors from '../../../styles/colors'

// images
import FillStarImg from '../../../assets/image/star/ic-fill-star.svg'
import EmptyStarImg from '../../../assets/image/star/ic-empty-star.svg'

export default function StarRating({ starPoint }) {
  const renderDetailRating = (starPoint) => {
    let copyArr = starPoint.arr.slice(0)

    return (
      <DetailWrapper>
        <PointDetail>
          {[5, 4, 3, 2, 1].map((ele, idx) => (
            <div key={idx}>{ele}점</div>
          ))}
        </PointDetail>
        <LineDetail>
          {copyArr.map((ele, idx) => (
            <div key={idx}>
              <span />
              <PercentLine percent={(ele / starPoint.len) * 100} />
            </div>
          ))}
        </LineDetail>

        <CountDetail>
          {copyArr.map((ele, idx) => (
            <span key={idx}>{ele}개</span>
          ))}
        </CountDetail>
      </DetailWrapper>
    )
  }

  const getStarRating = (point) => {
    // fill - true
    // empty - false
    let formatPoint = Math.floor(Number(point))
    let starList = [false, false, false, false, false]

    return starList.fill(true, 0, formatPoint)
  }

  return (
    <BoxShadow
      className="d-flex align-items-center"
      paddingVertical={35}
      paddingHorizontal={20}
    >
      <SummaryWrapper>
        <InfoSummary>
          <h1>{starPoint.avg}</h1>
          {starPoint?.avg &&
            getStarRating(starPoint.avg).map((star, idx) => (
              <StarInfo
                key={idx}
                src={star ? FillStarImg : EmptyStarImg}
                isFirst={idx === 0}
              />
            ))}
        </InfoSummary>
      </SummaryWrapper>
      <DivideWrapper />
      <ListWrapper>{renderDetailRating(starPoint)}</ListWrapper>
    </BoxShadow>
  )
}

const SummaryWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
`

const InfoSummary = styled.div`
  display: flex;
  align-items: baseline;

  h1 {
    font-size: 30px;
    margin-right: 20px;
    font-weight: 700;
  }

  @media ${(props) => props.theme.mobile} {
    align-items: flex-end;

    h1 {
      font-size: 20px;
      margin-right: 12px;
    }
  }
`

const StarInfo = styled.img`
  width: 28px;
  height: 28px;
  margin-right: 10px;

  @media (max-width: 768px) {
    width: 25px;
    height: 25px;
    margin-right: 0px;
    display: ${(props) => (props.isFirst ? 'flex' : 'none')};
  }
`

const DivideWrapper = styled.div`
  width: 1px;
  height: 160px;
  background-color: ${colors.W4};

  @media (max-width: 768px) {
    display: none;
  }
`

const ListWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const DetailWrapper = styled.div`
  display: flex;
  flex-direction: row;
`

const PointDetail = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  color: ${colors.G4};
  margin-right: 10px;

  div {
    margin-bottom: 10px;

    @media ${(props) => props.theme.mobile} {
      font-size: 14px;
    }
  }
`

const LineDetail = styled.div`
  display: flex;
  flex-direction: column;
  width: 127px;

  div {
    display: flex;
    align-items: center;
    height: 20px;
    margin-bottom: 10px;
    position: relative;
  }

  span:nth-child(1) {
    width: 100%;
    height: 4px;
    border-radius: 2px;
    background-color: ${colors.G3};
  }

  @media ${(props) => props.theme.mobile} {
    width: 66px;
  }
`

const PercentLine = styled.span`
  width: ${(props) => `${props.percent}%`};
  height: 4px;
  border-radius: 2px;
  background-color: ${colors.mainG};
  position: absolute;
`

const CountDetail = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  margin-left: 10px;
  color: ${colors.BK};

  span {
    margin-bottom: 10px;

    @media ${(props) => props.theme.mobile} {
      font-size: 14px;
    }
  }
`
